import Button from '@/components/atoms/button';
import clsx from 'clsx';

interface IProps {
    isChecked: boolean;
    onClickCheckbox: () => void;
    onClickWithdrawBtn: () => void;
}

const ExitView = ({ isChecked, onClickCheckbox, onClickWithdrawBtn }: IProps) => {
    return (
        <div className="container-style2">
            <div className="exit">
                <div className="inner">
      <div className="img"><img src="img/BI.png" alt="BI" /></div>
      <h3 className="body-n-n">탈퇴 전 확인하세요.</h3>
      <p className="body-n-n">탈퇴 후에는 이용중인 모든 전자지갑에 <br /> 접근할 수 없으며, <br /> 모든 데이터는 
      복구가 불가능합니다.</p>
      <div className="txt-box-exit">
          <p className="body-s-n">• 탈퇴 전에 전자지갑에 남아 있는 잔액을 반드시 <br /> 미리 출금해주세요.</p>
          <p className="body-s-n"><span>탈퇴 후에는 지갑 내 잔액을 복구하거나 조회할 수 있는 <br /> 방법이 없습니다.</span></p>
          <p className="body-s-n">• 탈퇴 후에는 모든 거래 내역 및 계정 관련 정보가 <br /> 삭제되며, 이 정보는 복구할 수 없습니다.</p>
      </div>
      <div className="checkbox-area">
          <input 
              type="checkbox" 
              id="confirmCheck"
              checked={isChecked}
              onChange={onClickCheckbox}
          />
          <label htmlFor="confirmCheck">안내사항을 모두 확인하였으며, 이에 동의합니다.</label>
      </div>
        <Button 
            caption="탈퇴하기" 
            className={clsx('l-button solid', {
                'disabled': !isChecked
            })} 
            disabled={!isChecked} 
            onClick={onClickWithdrawBtn} 
        />
    </div>
  </div>
</div>
    )
}

export default ExitView;